(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
class HeroSlider {
  constructor(container) {
    this.container = container;
    this.slides = this.container.querySelectorAll('.hero-slider__slide');
    this.actionWrappers = this.container.querySelectorAll('.hero-slider__actions-wrapper');
    if (this.slides.length < 1) return;

    this.prevButton = this.container.querySelector('.hero-slider__nav-button--prev');
    this.nextButton = this.container.querySelector('.hero-slider__nav-button--next');
    this.paginationContainer = this.container.querySelector('.hero-slider__pagination');
    
    this.currentIndex = 0;
    this.slideCount = this.slides.length;
    this.autoplaySpeed = 4500; // default; will be read from section settings if present

    this.init();
  }

  init() {
    if (this.slideCount > 1) {
      this.createPagination();
      this.addEventListeners();
      this.startAutoplay();
    }
    this.showSlide(0);
  }

  createPagination() {
    this.slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.classList.add('hero-slider__pagination-dot');
      dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
      dot.addEventListener('click', () => this.goToSlide(index));
      this.paginationContainer.appendChild(dot);
    });
    this.dots = this.paginationContainer.querySelectorAll('.hero-slider__pagination-dot');
  }

  // showSlide updated to sync slides, dots, action wrappers and apply tint
  showSlide(index) {
    const newIndex = (index + this.slideCount) % this.slideCount;
    
    this.slides.forEach(slide => slide.classList.remove('is-active'));
    if (this.dots) this.dots.forEach(dot => dot.classList.remove('is-active'));
    if (this.actionWrappers) this.actionWrappers.forEach(wrapper => wrapper.classList.remove('is-active'));

    this.slides[newIndex].classList.add('is-active');
    if (this.dots && this.dots.length > 0) this.dots[newIndex].classList.add('is-active');
    if (this.actionWrappers && this.actionWrappers.length > 0) this.actionWrappers[newIndex].classList.add('is-active');

    // --- Dynamic tint logic ---
    const activeWrapper = (this.actionWrappers && this.actionWrappers[newIndex]) ? this.actionWrappers[newIndex] : null;
    const actionsArea = this.container.querySelector('.hero-slider__actions-area');

    if (actionsArea && activeWrapper) {
      const tintHex = activeWrapper.dataset.tint || '#ffffff';

      // convert hex to rgba
      function hexToRgba(hex, alpha) {
        var h = (hex || '#ffffff').replace('#', '');
        if (h.length === 3) h = h.split('').map(c => c + c).join('');
        var bigint = parseInt(h, 16);
        var r = (bigint >> 16) & 255;
        var g = (bigint >> 8) & 255;
        var b = bigint & 255;
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
      }

      // subtle tints
          const tint10 = hexToRgba(tintHex, 0.18); // subtle top tint
          const tint20 = hexToRgba(tintHex, 0.33); // deeper overlay


      // set CSS vars
        actionsArea.style.setProperty('--tint-rgba-10', tint10);
        actionsArea.style.setProperty('--tint-rgba-20', tint20);


      // mark tinted
      actionsArea.classList.add('tinted');
    } else if (actionsArea) {
      actionsArea.style.removeProperty('--tint-rgba');
      actionsArea.style.removeProperty('--tint-rgba-06');
      actionsArea.classList.remove('tinted');
    }
    // --- end tint logic ---

    this.currentIndex = newIndex;
  }
  
  goToSlide(index) {
    this.showSlide(index);
    this.resetAutoplay();
  }

  nextSlide() {
    this.showSlide(this.currentIndex + 1);
  }

  prevSlide() {
    this.showSlide(this.currentIndex - 1);
  }

  startAutoplay() {
    if (Shopify && Shopify.designMode) return;
    this.stopAutoplay();

    // Read autoplay speed from the containing shopify-section DOM attribute
    const sectionEl = this.container.closest('.shopify-section');
    if (sectionEl) {
      const dataSpeed = sectionEl.getAttribute('data-autoplay-speed');
      const parsed = parseInt(dataSpeed, 10);
      if (!Number.isNaN(parsed) && parsed > 0) {
        this.autoplaySpeed = parsed;
      }
    }

    // Fallback (already defined in constructor as 4500)
    if (!this.autoplaySpeed || isNaN(this.autoplaySpeed)) {
      this.autoplaySpeed = 4500;
    }

    this.autoplayInterval = setInterval(() => this.nextSlide(), this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayInterval) clearInterval(this.autoplayInterval);
    this.autoplayInterval = null;
  }

  resetAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }

  handleKeydown(e) {
    if (e.key === 'ArrowLeft') { e.preventDefault(); this.prevSlide(); this.resetAutoplay(); }
    if (e.key === 'ArrowRight') { e.preventDefault(); this.nextSlide(); this.resetAutoplay(); }
  }

  addEventListeners() {
    if (this.nextButton) this.nextButton.addEventListener('click', () => { this.nextSlide(); this.resetAutoplay(); });
    if (this.prevButton) this.prevButton.addEventListener('click', () => { this.prevSlide(); this.resetAutoplay(); });
    this.container.addEventListener('mouseenter', this.stopAutoplay.bind(this));
    this.container.addEventListener('mouseleave', this.startAutoplay.bind(this));
    this.container.addEventListener('keydown', this.handleKeydown.bind(this));

    // touch support (basic)
    let startX = 0, dx = 0;
    const track = this.container.querySelector('.hero-slider-container');
    if (track) {
      track.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; this.stopAutoplay(); }, {passive:true});
      track.addEventListener('touchmove', (e) => { dx = e.touches[0].clientX - startX; }, {passive:true});
      track.addEventListener('touchend', () => { if (Math.abs(dx) > 50) { dx < 0 ? this.nextSlide() : this.prevSlide(); } dx = 0; this.startAutoplay(); }, {passive:true});
    }
  }
}

document.addEventListener('shopify:section:load', function(event) {
  const container = event.target.querySelector(`[data-section-id="${event.detail.sectionId}"]`);
  if (container) new HeroSlider(container);
});

document.querySelectorAll('[data-section-id]').forEach(container => {
  if (container.querySelector('.hero-slider-container')) {
    new HeroSlider(container);
  }
});

  } catch(e) { console.error(e); }
})();
})();
